import { RouteConfig } from 'vue-router';
import CatalogComponent from './catalog.component.vue';
import ShppingCart from './components/shopping-cart.vue';
export const catalogRoute: RouteConfig = {
  path: 'catalog',
  component: CatalogComponent,
};
export const shoppingCartRoute: RouteConfig = {
  path: 'cart',
  component: ShppingCart,
};
